import { AptevaClient, pickBaseURL, pickKioskKey } from "@apteva/web-sdk";

const DEFAULT_APTEVA_BASE_URL = "https://agents.schwartzindustries.com";
const DEFAULT_APTEVA_KIOSK_KEY = "wk_live_33fb167ea1c4205f9d79c884f2258049ba36";
export const APTEVA_PROJECT_ID = "1778744828632-6333b54afcff0fad";

declare global {
  interface Window {
    apa?: ((eventName: string, properties?: Record<string, unknown>) => void) & {
      q?: unknown[];
    };
    __SOCIALCAST_APTEVA_BASE_URL__?: string;
    __SOCIALCAST_APTEVA_KIOSK_KEY__?: string;
  }
}

function runtimeValue(name: "__SOCIALCAST_APTEVA_BASE_URL__" | "__SOCIALCAST_APTEVA_KIOSK_KEY__", fallback: string) {
  if (typeof window === "undefined") return fallback;
  return window[name] || fallback;
}

export function aptevaClient() {
  return new AptevaClient({
    baseURL: pickBaseURL(runtimeValue("__SOCIALCAST_APTEVA_BASE_URL__", DEFAULT_APTEVA_BASE_URL)),
    apiKey: pickKioskKey(runtimeValue("__SOCIALCAST_APTEVA_KIOSK_KEY__", DEFAULT_APTEVA_KIOSK_KEY)),
  });
}

function compactObject(values: Record<string, unknown>) {
  return Object.fromEntries(
    Object.entries(values).filter(([, value]) => value !== undefined && value !== null && value !== ""),
  );
}

export function trackEvent(eventName: string, properties: Record<string, unknown> = {}) {
  if (typeof window === "undefined" || typeof window.apa !== "function") return;
  window.apa(eventName, compactObject(properties));
}

export function trackPageView(path: string, properties: Record<string, unknown> = {}) {
  trackEvent("socialcast_site_page_view", {
    path,
    title: typeof document === "undefined" ? undefined : document.title,
    ...properties,
  });
}
